import { render } from "./ToastMaster.vue?vue&type=template&id=4c0bf778"
import script from "./ToastMaster.vue?vue&type=script&lang=js"
export * from "./ToastMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__